import React, { useContext, useState, useEffect, useRef } from "react";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import swal from "sweetalert";
import {
  BASE_URL_API,
  BASE_URL_APISERVICES,
  BASE_URL_API_TRANXT_API,
} from "../../utils/Constants";
import { GlobalContext } from "../../Context/GlobalState";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

const apps = [
  { label: "BUMPPY", value: "BUMPPY" },
  { label: "BUMPPY_SALES", value: "BUMPPY_SALES" },
];

const DocKYCInitiate = () => {
  const initialState = {
    version: "",
    user: { label: "Select User", value: "" },
  };

  const [state, setState] = useState(initialState);
  const [users, setUsers] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const validateForm = () => {
    if (state.user.value == "") {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    createTariff();
  };

  const clearForm = () => {
    setState(initialState);
  };

  const createTariff = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        adminId: user.pkid,
        userid: state.user.value,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.DOC_KYC}`,
        requestOptions
      );

      const data = await res.json();
      if (data.status == "0") {
        swal("Success", data.msg, "success");
        clearForm();
      } else {
        swal("Failed", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Failed", "Error From Server", "error");
    }
  };

  const getAllUserList = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        usertype: "",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_USER_LIST}`,
        requestOptions
      );
      const data = await res.json();
      setUsers(
        data.data.map((user) => {
          return { value: user.uCode, label: `${user.uName} [${user.uCode}]` };
        })
      );
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };
  useEffect(() => {
    getAllUserList();
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <div style={{ borderRadius: "22px" }} className="card m-4 p-0">
        <div className="card-body">
          <div>
            <div
              style={{
                padding: "12px",
                background: "#3676D8",
                color: "#FFF",
                fontWeight: "bolder",
              }}
            >
              Doc KYC Initiate
            </div>

            <div>
              <div className="row">
                <div className="col p-0 mr-2">
                  <Form.Group>
                    <Form.Label>
                      <span style={{ color: "red" }}>*</span>
                      {`Select User`}
                    </Form.Label>
                    <Select
                      options={users}
                      value={state.user}
                      onChange={(e) => {
                        setState({ ...state, user: e });
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="col px-0 mt-4">
                  <Button
                    className="rounded-0 btn-block"
                    variant="success"
                    onClick={validateForm}
                  >
                    {" "}
                    Initiate Doy KYC
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DocKYCInitiate;
